import React from 'react';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';

import { Spacing } from '../../theme';
import { PopupCreateContainer } from '../../epic/popup-create';
import { PopupAdminListContainer } from '../../epic/admin-popup-list';

export const Page: React.FC<RouteComponentProps> = () => {
  return (
    <Container>
      <PopupCreateContainer />
      <PopupAdminListContainer />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing(4)};
  width: 100%;
  max-width: 400px;
`;
